import { MatDialogConfig } from "@angular/material/dialog";

export const MobileFullScreenViewDialog: MatDialogConfig = {
  panelClass: ["mobile-full-screen-view", "no-tap-highlight"],
};
